import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Certification } from 'app/shared/objects/certification';

@Component({
  selector: 'app-certification-iso-abnt',
  templateUrl: './certification-iso-abnt.component.html',
  styleUrls: ['./certification-iso-abnt.component.scss']
})
export class CertificationIsoAbntComponent implements OnInit {

  @Input() certification: Certification;
  @Output() begin = new EventEmitter<Certification>()

  constructor() { }

  ngOnInit(): void {
  }

  handleBegin(): void {
    this.begin.emit(this.certification);
  }

}
